export enum OrderState {
	open = 'open',
	done = 'done',
	cancelled = 'cancelled',
}

export enum OrderItemState {
	pending = 'pending',
	ready_to_cook = 'ready_to_cook',
	cooking = 'cooking',
	ready_to_serve = 'ready_to_serve',
	served = 'served',
	done = 'done',
	rejected = 'rejected',
}
